export function convertAmount(rate: number, amount: number): number {
  return +Number(amount / rate).toFixed(2);
}

export function amountFormatter(value: number | string): string {
  if (value === null || value === undefined || value === '') return '';
  return parseFloat(value.toString()).toFixed(2);
}

export function currencyFormatter(value: number | string): string {
  if (value === null || value === undefined || value === '') return '0.00';
  const num = parseFloat(value.toString());
  return isNaN(num) ? '0.00' : num.toFixed(2);
}

export function amountParser(value: string): string {
  return value.replace(/[^\d.-]/g, '');
}